import React from 'react';
import {
  FaClipboardCheck,
  FaChalkboardTeacher,
  // FaSyncAlt,
  FaUsersCog,
} from 'react-icons/fa';
import { BsShieldCheck } from 'react-icons/bs';

export const services = [
  {
    number: '01',
    icon: <FaChalkboardTeacher />,
    eyebrow: 'Online & Classroom',
    title: 'Safety Training',
    description:
      'Flexible online and classroom safety training designed to keep workers prepared, certified, and job-ready.',
    link: '/training',
    buttonText: 'Explore Training',
  },

  {
    number: '02',
    icon: <FaUsersCog />,
    eyebrow: 'For Businesses',
    title: 'Company Training & Tracking',
    description:
      'Assign employee training, manage course activity, and keep workplace training records organized in one place.',
    link: '/company-training',
    buttonText: 'Learn More',
  },

  {
    number: '03',
    icon: <FaClipboardCheck />,
    eyebrow: 'Digital Tools',
    title: 'Digital Safety Forms',
    description:
      'Create and manage digital workplace safety forms that teams can complete, save, and access online.',
    link: '/digital-safety-forms',
    buttonText: 'Explore Forms',
  },

  {
    number: '04',
    icon: <BsShieldCheck />,
    eyebrow: 'Workplace Resources',
    title: 'Safety Manuals',
    description:
      'Keep important workplace safety manuals and documentation organized and accessible to your team.',
    link: '/safety-manuals',
    buttonText: 'View Manuals',
  },

  {
    number: '05',
    icon: <FaClipboardCheck />,
    eyebrow: 'Certified Support',
    title: 'Safety Audits',
    description:
      'Certified workplace safety audits designed to support stronger systems, safer operations, and compliance.',
    link: '/safety-audits',
    buttonText: 'Learn More',
  },

  {
    number: '06',
    icon: <BsShieldCheck />,
    eyebrow: 'Safety Equipment',
    title: 'Safety Products',
    description:
      'Professional-grade safety supplies and equipment for protecting workers and supporting safer workplaces.',
    link: '/products',
    buttonText: 'Browse Products',
  },

  {
    number: '07',
    icon: <FaUsersCog />,
    eyebrow: 'Coming Soon',
    title: 'Contractor Management',
    description:
      'Simplified tools for managing contractor information, training records, and workplace compliance.',
    link: '#',
    buttonText: 'Coming Soon',
    disabled: true,
  },
];
